@if (indicatorVisible) {
  <div class="message-indicator" [@focusedTrigger]="indicatorVisible" tabindex="0">
    {{ unreadQueue?.length }}
  </div>
}
